import { ToastrModule } from 'ngx-toastr';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { HomeComponent } from './pages/home/home.component';
import { ProgramsComponent } from './pages/programs/programs.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { CourseComponent } from './pages/course/course.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { LayoutComponent } from './shared/layout/layout.component';
import { MatCardModule } from '@angular/material/card';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { MatInputModule } from '@angular/material/input';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProgramComponent } from './shared/components/modals/program/program.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NewsComponent } from './pages/news/news.component';
import { CustomMatModule } from './material-module';
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CommonModule, DatePipe } from '@angular/common';
import { QuestionsComponent } from './shared/components/modals/questions/questions.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { EducationalProgramComponent } from './pages/educational-program/educational-program.component';
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { FaqComponent } from './pages/faq/faq.component';
import { ModalComponent } from './shared/components/modals/modal/modal.component';
import { LoginComponent } from './pages/login/login.component';
import { BasicAuthInterceptor } from './helpers/basic-auth.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { AuthGuard } from './helpers/auth.guard';
import { EMAIL_SENDER_BASE_URL } from './services/email-sender';
import { RejectModalComponent } from './shared/components/modals/reject-modal/reject-modal.component';
import { NewsItemComponent } from './pages/news/news-item/news-item.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
@NgModule({
  exports: [
    ModalComponent,
    RejectModalComponent,
  ],
  declarations: [
    AppComponent,
    ContactsComponent,
    ProgramsComponent,
    ProjectsComponent,
    CourseComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    LayoutComponent,
    ProgramComponent,
    NewsComponent,
    QuestionsComponent,
    EducationalProgramComponent,
    FaqComponent,
    ModalComponent,
    RejectModalComponent,
    LoginComponent,
    NewsItemComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    MatSlideToggleModule,
    CollapseModule.forRoot(),
    MatCardModule,
    MatInputModule,
    ModalModule.forRoot(),
    MatRadioModule,
    CarouselModule.forRoot(),
    AccordionModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'contacts', component: ContactsComponent },
      { path: 'info', component: FaqComponent },
      { path: 'programs', component: ProgramsComponent },
      { path: 'projects', component: ProjectsComponent },
      { path: 'course', component: CourseComponent },
      { path: 'course/:id', component: CourseComponent },
      { path: 'news', component: NewsComponent },
      { path: 'news/:id', component: NewsItemComponent },
      { path: 'projects', component: ProjectsComponent },
      { path: 'program/:id', component: EducationalProgramComponent },
      { path: 'login', component: LoginComponent },
      {
        path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard]
      },
      {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full'
      },
    ]),
    CustomMatModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    AngularMultiSelectModule,
    CommonModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(),
  ],
  providers: [
    BsModalRef,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: EMAIL_SENDER_BASE_URL, useValue: 'https://sender.uni-dubna.ru' },
  ],
  bootstrap: [AppComponent, ProgramComponent],
  entryComponents: [ModalComponent, RejectModalComponent]
})
export class AppModule {
}
